module.exports = __webpack_public_path__ + "static/media/tool_logo_arachni.ac5b15cb.png";